"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.camelize = camelize;
exports.capitalize = capitalize;
exports.uncapitalize = uncapitalize;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.string.trim.js");

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function uncapitalize(str) {
  return str.charAt(0).toLowerCase() + str.slice(1);
}

function camelize(str) {
  return uncapitalize(str.trim()).replace(/[^a-zA-Z\d]+(.)/g, (m, chr) => chr.toUpperCase());
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjYXBpdGFsaXplIiwic3RyIiwiY2hhckF0IiwidG9VcHBlckNhc2UiLCJzbGljZSIsInVuY2FwaXRhbGl6ZSIsInRvTG93ZXJDYXNlIiwiY2FtZWxpemUiLCJ0cmltIiwicmVwbGFjZSIsIm0iLCJjaHIiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvdGV4dC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZnVuY3Rpb24gY2FwaXRhbGl6ZShzdHI6IHN0cmluZykge1xuICByZXR1cm4gc3RyLmNoYXJBdCgwKS50b1VwcGVyQ2FzZSgpICsgc3RyLnNsaWNlKDEpXG59XG5cbmV4cG9ydCBmdW5jdGlvbiB1bmNhcGl0YWxpemUoc3RyOiBzdHJpbmcpIHtcbiAgcmV0dXJuIHN0ci5jaGFyQXQoMCkudG9Mb3dlckNhc2UoKSArIHN0ci5zbGljZSgxKVxufVxuXG5leHBvcnQgZnVuY3Rpb24gY2FtZWxpemUoc3RyOiBzdHJpbmcpIHtcbiAgcmV0dXJuIHVuY2FwaXRhbGl6ZShzdHIudHJpbSgpKS5yZXBsYWNlKC9bXmEtekEtWlxcZF0rKC4pL2csIChtLCBjaHIpID0+IGNoci50b1VwcGVyQ2FzZSgpKVxufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBTyxTQUFTQSxVQUFULENBQW9CQyxHQUFwQixFQUFpQztFQUN0QyxPQUFPQSxHQUFHLENBQUNDLE1BQUosQ0FBVyxDQUFYLEVBQWNDLFdBQWQsS0FBOEJGLEdBQUcsQ0FBQ0csS0FBSixDQUFVLENBQVYsQ0FBckM7QUFDRDs7QUFFTSxTQUFTQyxZQUFULENBQXNCSixHQUF0QixFQUFtQztFQUN4QyxPQUFPQSxHQUFHLENBQUNDLE1BQUosQ0FBVyxDQUFYLEVBQWNJLFdBQWQsS0FBOEJMLEdBQUcsQ0FBQ0csS0FBSixDQUFVLENBQVYsQ0FBckM7QUFDRDs7QUFFTSxTQUFTRyxRQUFULENBQWtCTixHQUFsQixFQUErQjtFQUNwQyxPQUFPSSxZQUFZLENBQUNKLEdBQUcsQ0FBQ08sSUFBSixFQUFELENBQVosQ0FBeUJDLE9BQXpCLENBQWlDLGtCQUFqQyxFQUFxRCxDQUFDQyxDQUFELEVBQUlDLEdBQUosS0FBWUEsR0FBRyxDQUFDUixXQUFKLEVBQWpFLENBQVA7QUFDRCJ9